import React, {useMemo} from 'react';
import {Props} from './Props';
import {OtmConstraint} from '../OtmConstraint';
import {LevelDash} from '../LevelDash';

export const OtmConstraintAnd: React.FunctionComponent<Props> = ({constraint, level}) => {
    return (
        <>
            <p style={{fontWeight: 'bold'}}>
                <LevelDash level={level} />
                And Constraint:
            </p>

            {useMemo(
                () =>
                    constraint.and.map((andConstraint, index) => (
                        <OtmConstraint key={index} constraint={andConstraint} level={level + 1} />
                    )),
                [constraint, level],
            )}
        </>
    );
};
